import { atom } from "recoil";
import { ContextNotification } from "../../types";

export const contextNotificationAtom = atom<ContextNotification>({
  key: "contextNotificationAtom",
  default: { isVisible: false, message: "default", type: "info" },
});
